import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../redux/actions/authActions";
import SidebarItem from "./sidebarItem";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";
import More from "../../../assets/icons/sidebar/more";
import moreUp from "../../../assets/icons/moreUp.svg";
import moreDown from "../../../assets/icons/moreDown.svg";
import faq from "../../../assets/faq.svg";
import support from "../../../assets/life-ring.svg";
import userLogo from "../../../assets/userProfile.svg";
import { AnimatePresence, motion } from "framer-motion";
import logoutLogo from "../../../assets/signOut.svg";
import LogoutModal from "../../modals/logoutModal";

const SidebarComponent = ({ userPermissionList, sidebarConfig }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("userType");
  const logo = localStorage.getItem("logo");
  const componentRef = useRef(null);

  const [logoutShow, setLogoutShow] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [supportOpen, setSupportOpen] = useState(true);
  const [moreOptions, setMoreOptions] = useState(false);
  const [userData, setUserData] = useState(null);
  const handleLogoutClose = () => setLogoutShow(false);
  const handleLogoutShow = () => setLogoutShow(true);

  const activePath = "/" + location.pathname.split("/")[1];
  const activeSubPath = "/" + location.pathname.split("/")[2];

  useEffect(() => {
    if (userType === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      setUserData(permissionData?.map((item) => item?.module_name));
    }
  }, []);

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const logoutSuccess = (data) => {
    setShowSuccessMsg(capitalize(data.data.message));
    setShowSuccessPopup(true);
    setTimeout(() => navigate("/"), 2000);
  };

  const logoutError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        setMoreOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="h-100">
      <div className="d-flex flex-column justify-content-between mx-0 h-100">
        <div className="p-3 overflow-auto h-100">
          <div className="d-flex justify-content-center">
            {logo != "null" && (
              <img src={logo} alt="Johnson-Johnson" className="company-image" />
            )}
          </div>
          <ul className="nav-options">
            {sidebarConfig.map((item) =>
              typeof item.visible === "function"
                ? item.visible({ userType, userPermissionList }) && (
                    <SidebarItem
                      key={item.label}
                      item={item}
                      activePath={activePath}
                      activeSubPath={activeSubPath}
                      navigate={navigate}
                    />
                  )
                : null
            )}
          </ul>
        </div>
        <div className="position-relative px-3" ref={componentRef}>
          <div
            className={`p-1 d-flex align-items-center justify-content-between ${
              moreOptions ? "nav-items-active2" : "nav-items"
            }`}
            onClick={() => {
              setMoreOptions(!moreOptions);
              setSupportOpen(false);
            }}
          >
            <div>
              <More fill={moreOptions ? "#7065e4" : "#747F9E"} />
              <span className="nav-text fw_600">More</span>
            </div>
            <div className="mx-2">
              <img src={moreOptions ? moreDown : moreUp} />
            </div>
          </div>

          <AnimatePresence>
            {moreOptions && (
              <motion.div
                className="more-popup-container p-1"
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 0, opacity: 0 }}
              >
                {/* FAQ - shown only if not super_user */}
                {userType !== "super_user" && (
                  <li
                    className={`nav-items d-flex justify-content-start align-items-center gap-2 p-1 ${
                      activePath === "/faq" ? "nav-items-active" : ""
                    }`}
                    onClick={() => navigate("/faq")}
                  >
                    <img src={faq} />
                    <span className="nav-text-2">FAQ's</span>
                  </li>
                )}

                {/* Contact Support - conditional by userType and permissions */}
                {(userType !== "super_user" ||
                  (userType === "super_user" &&
                    userData?.includes("Support"))) && (
                  <li
                    className={`nav-items d-flex justify-content-start align-items-center gap-2 p-1 ${
                      activePath === "/contact-support"
                        ? "nav-items-active"
                        : ""
                    }`}
                    onClick={() => navigate("/contact-support")}
                  >
                    <img src={support} />
                    <span className="nav-text-2">Contact Support</span>
                  </li>
                )}

                {/* Logout */}
                <li
                  className="nav-items d-flex justify-content-start align-items-center  gap-2 p-1"
                  onClick={handleLogoutShow}
                >
                  <img src={userLogo} />
                  <div className="logout-div">
                    <span className="nav-text-2">Logout</span>
                    <img src={logoutLogo} />
                  </div>
                </li>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
      <LogoutModal
        logoutShow={logoutShow}
        handleLogoutClose={() => setLogoutShow(false)}
        logoutFunc={logoutHandler}
      />
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </div>
  );
};
export default SidebarComponent;
